module.exports = __webpack_public_path__ + "img/banner-ccb.2615c127.png";